module.exports = __webpack_public_path__ + "img/life-cover.4cef1e61.svg";